import { DeviceInfo } from "@nelo/signup-lib/dist/utils/Headers"
import { UAParser } from "ua-parser-js"
import { v4 as uuidV4 } from "uuid"

const generateDeviceId = (): string => {
  return uuidV4().replace(/-/g, "")
}

const MAX_LENGTH = 200

export const getDeviceInfo = (): DeviceInfo => {
  if (typeof window === "undefined") {
    return {
      timeZone: "UTC",
      id: "server-side-placeholder",
      manufacturer: "Server",
      model: "Server",
      acceptLanguage: "en",
      version: "0.1.0",
      versionCode: "1",
      platform: "web",
      systemVersion: "Server",
    }
  }

  const parser = new UAParser(navigator.userAgent)
  const browser = parser.getBrowser()

  const systemVersion = browser.name && browser.version ? `${browser.name}/${browser.version}` : navigator.userAgent
  const trimmedSystemVersion = systemVersion.length > MAX_LENGTH ? systemVersion.substring(0, MAX_LENGTH) : systemVersion

  return {
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    id: generateDeviceId(),
    manufacturer: navigator.vendor || "Google Inc.",
    model: navigator.platform || "MacIntel",
    acceptLanguage: navigator.language,
    version: "0.1.0",
    versionCode: "1",
    platform: "web",
    systemVersion: trimmedSystemVersion,
  }
}
